import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {ActionCreators} from '../actions/';
import { appBasePath } from '../constants/staticData';

export default function CarProfileContainer(ComposedComponent) {
  class CarProfileContainer extends Component {
    constructor(props) {
      super(props);
    }
    componentWillUpdate(nextProps) {
      if (nextProps.bookingRequestReducer && nextProps.bookingRequestReducer.currentComponentKey) {
        nextProps.router.push(appBasePath + nextProps.bookingRequestReducer.currentComponentKey);
      }
      if(nextProps.commonReducer && nextProps.commonReducer.currentComponentKey){
        nextProps.router.push(appBasePath + nextProps.commonReducer.currentComponentKey);
      }
    }
    render() {
      return (<ComposedComponent {...this.props}/>);
    }
  }

  function mapStateToProps(state) {
    return {carProfileReducer: state.carProfileReducer, authReducer: state.authReducer, commonReducer: state.commonReducer, bookingRequestReducer: state.bookingRequestReducer};
  }

  function mapDispatchToProps(dispatch) {
    return {
      actions: bindActionCreators(ActionCreators, dispatch)
    };
  }

  return connect(mapStateToProps, mapDispatchToProps)(CarProfileContainer);
}

CarProfileContainer.contextTypes = {
  router: React.PropTypes.object
};
